/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Row_ApprovalsInputs */



/**
* | output |
* | --- |
* | "Approvals and limits" |
*
* @param {Agent_Builder_Row_ApprovalsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_row_approvals = /** @type {((inputs?: Agent_Builder_Row_ApprovalsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Row_ApprovalsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Freigaben und Grenzen")
	return /** @type {LocalizedString} */ ("Approvals and limits")
});